import React, { useState, useMemo, useEffect } from "react";
import {
  HeaderContainer,
  HeaderLeftContainer,
  TypographyContainer,
  HeaderRightContainer,
  IconContainer,
  AgentSearchContainer
} from "./Header.styled";
import { Typography, Button, Icon, Select, Tag, ButtonMenu } from "@ann/web-components";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../../../../hooks";
import { observer } from "mobx-react";
import { ModalBase } from "../Modal"

const Header = observer(({ agentName, agentId, retrySave, hasUnsavedChanges, isSaving, saveImmediately }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const { playgroundConfigStore, knowledgeStore } = useStore();
  const { agentStore } = playgroundConfigStore;
  const [showModalArchive, setShowModalArchive] = useState(false);
  const [showModalPublish, setShowModalPublish] = useState(false);

  useEffect(() => {
    agentStore.agentListStore.fetchAgentList();
  }, []);

  // useEffect para cargar el agente específico
  useEffect(() => {
    if (agentId) {
      agentStore.fetchAgent(agentId);
    }
    // Resetear el término de búsqueda cuando cambia el agente
    setSearchTerm('');
  }, [agentId, agentStore]);


  const agents = useMemo(() => {
    return agentStore.agentListStore.agents.map(agent => ({
      label: agent.name,
      value: agent.uuid,
      shortLabel: agent.name.substring(0, 2).toUpperCase(),
      description: agent.description
    }));
  }, [agentStore.agentListStore.agents]);

  const filteredAgents = useMemo(() => {
    if (!searchTerm.trim()) return agents;

    const searchLower = searchTerm.toLowerCase();
    return agents.filter(agent =>
      agent.label.toLowerCase().includes(searchLower) ||
      agent.description.toLowerCase().includes(searchLower)
    );
  }, [searchTerm, agents]);

  const handleSearch = (searchValue) => {
    setSearchTerm(searchValue);
  };

  const handleSelection = (value, option) => {
    if (value) {
      navigate(`/v2/playground/${value}/configuration`);
      // Limpiar la selección para que el Select siempre muestre el placeholder
      setSearchTerm('');
    }
  };

  const handleBackClick = () => {
    if (knowledgeStore) {
      knowledgeStore.resetDocumentList();
    }
    navigate("/v2/AgentsView");
  };

  const handleActionSelect = (action) => {
    if (action === 'archive') {
      setShowModalArchive(true);
    }
  };

  const handleArchiveConfirm = () => {
    // Aquí irá la lógica para archivar
    console.log('Archivando agente...');
    setShowModalArchive(false);
  };

  const handleCloseModal = () => {
    setShowModalArchive(false);
  };

  const handlePublishConfirm = () => {
    setShowModalPublish(true);
  }

  return (
    <HeaderContainer>
      <HeaderLeftContainer>
        <IconContainer onClick={handleBackClick}>
          <Icon name="arrowLeft" size="medium" />
        </IconContainer>
        <TypographyContainer title={agentStore.name}>
          <Typography category="title" size="large" weight="bold" maxCharacters={30}>
            {agentStore.name || 'Agent'}
          </Typography>
        </TypographyContainer>

        <AgentSearchContainer>
          <Select
            key={`agent-select-${agentId}`}
            placeholder={agentStore.agentListStore.isLoading ? "Loading agents..." : "Search and select agent"}
            onChange={handleSelection}
            size="small"
            width="auto"
            minWidth="auto"
            disabled={agentStore.agentListStore.isLoading}
          >
            <Select.Menu width="278px" minWidth="278px">
              <Select.Search
                placeholder='Search agents...'
                onChange={handleSearch}
                label=""
              />
              {agentStore.agentListStore.isLoading ? (
                <Select.Item value="" label="Loading agents..." disabled>
                  Loading agents...
                </Select.Item>
              ) : filteredAgents.length === 0 ? (
                <Select.Item value="" label="No agents found" disabled>
                  No agents found
                </Select.Item>
              ) : (
                filteredAgents.map((agent) => (
                  <Select.Item
                    key={agent.value}
                    value={agent.value}
                    label={agent.label}
                    shortLabel={agent.shortLabel}
                  >
                    <div>
                      <div>{agent.label}</div>
                      {agent.description && (
                        <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
                          {agent.description}
                        </div>
                      )}
                    </div>
                  </Select.Item>
                ))
              )}
            </Select.Menu>
          </Select>
        </AgentSearchContainer>

      </HeaderLeftContainer>

      <HeaderRightContainer>
        <ButtonMenu
          iconPosition="right"
          label="Actions"
          menuPosition="bottom"
          onChange={handleActionSelect}
          size="medium"
          type="secondary"
          width="auto"
        >
          <ButtonMenu.Menu>
            <ButtonMenu.Item
              label="Archive"
              value="archive"
            >
              Archive
            </ButtonMenu.Item>
            <ButtonMenu.Item
              label="Share"
              value="share"
            >
              Share
            </ButtonMenu.Item>
          </ButtonMenu.Menu>
        </ButtonMenu>
        {/*<Button
          label="Publish"
          size="medium"
          type="primary"
          disabled={true}
          onClick={() => handlePublishConfirm(true)}
        />*/}
      </HeaderRightContainer>

      {showModalArchive && (
        <ModalBase
          isOpen={showModalArchive}
          onClose={handleCloseModal}
          onClick={handleArchiveConfirm}
          title={`Are you sure you want to archive ${agentStore.name}?`}
          description="You can restore it anytime from the archived agents list."
          buttonTitle="Archive Agent"
          disabled={true}
          modalWidth="852px" />
      )}
      {showModalPublish && (
        <ModalBase
          isOpen={showModalPublish}
          onClose={() => setShowModalPublish(false)}
          onClick={() => setShowModalPublish(false)}
          title='Ready to publish this agent?'
          description="Your changes will go live instantly and may influence how agents interact on the platform."
          buttonTitle="Yes, Publish"
          modalWidth="777px" />
      )}

    </HeaderContainer>
  );
});

export default Header;
